(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4003],{

/***/ 52417:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/hero-bug-right.5afcc5fc.gif","height":400,"width":400});

/***/ }),

/***/ 24035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FooterCallToAction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Home/Home.module.scss
var Home_module = __webpack_require__(19350);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./components/Products/Products.module.scss
var Products_module = __webpack_require__(49879);
var Products_module_default = /*#__PURE__*/__webpack_require__.n(Products_module);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./public/images/hero-bug-right.gif
var hero_bug_right = __webpack_require__(52417);
;// CONCATENATED MODULE: ./public/images/safety-security-section.gif
/* harmony default export */ var safety_security_section = ({"src":"/_next/static/media/safety-security-section.b1e9c13f.gif","height":700,"width":700});
// EXTERNAL MODULE: ./components/common/Buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(29204);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
;// CONCATENATED MODULE: ./components/common/CallToAction/FooterCallToAction.tsx









const FooterCallToAction = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Home_module_default()).callToActionBackground,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((Home_module_default()).anchorTitle, (Home_module_default()).ctaContainer),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Home_module_default()).footerImageRight,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: hero_bug_right/* default */.Z,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Products_module_default()).subtleBadge,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy4",
                        emphasis: true,
                        children: "Try Highlight Today"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: (Home_module_default()).ctaTitle,
                    children: [
                        "Get the ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Home_module_default()).highlightedText,
                            children: "visibility"
                        }),
                        " you need"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((Home_module_default()).buttonContainer, (Home_module_default()).tryButtonContainer),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                        href: "https://app.highlight.io/sign_up",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            type: "copy2",
                            emphasis: true,
                            children: "Get started for free"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Home_module_default()).footerImageLeft,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: safety_security_section,
                        alt: ""
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 5945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
;// CONCATENATED MODULE: ./components/Products/products.ts
//all products and snippets are defined below for the product page
//referenced in ProductDropdown and sitemap
//whitespace ensures that the two code blocks (front-end and back-end) are the same height.
const defaultFrontendSnippet = "\n\nimport React from 'react'\nimport { H } from 'highlight.run'\nimport { ErrorBoundary } from '@highlight-run/react'\n\nH.init('<YOUR_PROJECT_ID>') // Get your project ID from https://app.highlight.io/setup\n\nReactDOM.render(\n	<React.StrictMode>\n		<ErrorBoundary>\n			<App />\n		</ErrorBoundary>\n	</React.StrictMode>,\n	document.getElementById('root'),\n)\n";
const expressSnippet = "\n\nimport { Handlers } from '@highlight-run/node'\n\nconst app = express()\n\n// define any configurations needed\n// <https://docs.highlight.run/api/hinit#w0-highlightoptions>\nconst highlightOptions = {projectID: 'YOUR_PROJECT_ID'}\nconst highlightHandler = Handlers.errorHandler(highlightOptions)\napp.use(highlightHandler)\n\napp.use('/error', () => {\n  throw new Error('a fake failure was thrown')\n})\n\n";
const goSnippet = '\n\nimport (\n  "github.com/highlight/highlight/sdk/highlight-go"\n)\n\nfunc main() {\n  //...application logic...\n  highlight.Start()\n  defer highlight.Stop()\n  //...application logic...\n}\n\n\n\n\n';
const nodeSnippet = "\n\nimport { H } from '@highlight-run/node'\n\nconst highlightOptions = {}\nif (!H.isInitialized()) {\n  H.init(highlightOptions)\n}\n\nconst onError = (request, error) => {\n	const parsed = H.parseHeaders(request.headers)\n	if (parsed !== undefined) {\n		H.consumeError(error, parsed.secureSessionId, parsed.requestId)\n	}\n}\n\n";
const nextBackendSnippet = "\n\nimport { withHighlight } from '../highlight.config'\n\nconst handler = async (req, res) => {\n  res.status(200).json({ name: 'Jay' })\n}\n\nexport default withHighlight(handler)\n\n\n\n\n\n\n\n";
const angularSnippet = "\n\n//main.ts\nimport { H } from 'highlight.run';\n\nH.init(\n    \"<YOUR_PROJECT_ID>\", // Get your project ID from https://app.highlight.io/setup\n    networkRecording: {\n        enabled: true,\n        recordHeadersAndBody: true,\n    },\n    tracingOrigins: true // Optional configuration of Highlight features\n);\n";
const gatsbySnippet = "\n\nmodule.exports = {\n	plugins: [\n		{\n			resolve: '@highlight-run/gatsby-plugin-highlight',\n			options: {\n				orgID: '<YOUR_PROJECT_ID>', // Get your project ID from https://app.highlight.io/setup\n			},\n		},\n	],\n}\n";
const nextSnippet = "\n\nimport type { AppProps } from 'next/app'\nimport { H } from 'highlight.run'\nimport { ErrorBoundary } from '@highlight-run/react'\n\nH.init('<YOUR_PROJECT_ID>') // Get your project ID from https://app.highlight.io/setup\n\nfunction MyApp({ Component, pageProps }: AppProps) {\n	return (\n		<ErrorBoundary>\n			<Component {...pageProps} />\n		</ErrorBoundary>\n	)\n}\nexport default MyApp\n";
const reactSnippet = "\n\nimport React from 'react'\nimport { H } from 'highlight.run'\nimport { ErrorBoundary } from '@highlight-run/react'\n\nH.init('<YOUR_PROJECT_ID>') // Get your project ID from https://app.highlight.io/setup\n\nReactDOM.render(\n	<React.StrictMode>\n		<ErrorBoundary>\n			<App />\n		</ErrorBoundary>\n	</React.StrictMode>,\n	document.getElementById('root'),\n)\n";
const vueSnippet = "\n\nimport { H } from 'highlight.run'\nimport { createApp } from 'vue'\nimport App from './App.vue'\n\nH.init('9me23yd2') // Get your project ID from https://app.highlight.io/setup\n\ncreateApp(App).mount('#app')\n";
const svelteSnippet = "\n\n... %svelte.head%\n\n<script src=\"https://cdn.jsdelivr.net/npm/highlight.run@latest\"></script>\n<script>\n	window.H.init('<YOUR_PROJECT_ID>')\n</script>\n\n...\n";
const PRODUCTS = {
    react: {
        type: "frontend",
        docsLink: "/docs/getting-started/client-sdk/reactjs",
        slug: "react",
        title: "React",
        snippets: [
            reactSnippet
        ]
    },
    next: {
        type: "frontend",
        docsLink: "/docs/getting-started/client-sdk/nextjs",
        slug: "next",
        title: "Next.js",
        types: [
            "Frontend",
            "Backend"
        ],
        snippets: [
            nextSnippet,
            nextBackendSnippet
        ]
    },
    angular: {
        type: "frontend",
        docsLink: "/docs/getting-started/client-sdk/angular",
        slug: "angular",
        title: "Angular",
        snippets: [
            angularSnippet
        ]
    },
    gatsby: {
        type: "frontend",
        docsLink: "/docs/getting-started/client-sdk/gatsbyjs",
        slug: "gatsby",
        title: "Gatsby.js",
        snippets: [
            angularSnippet
        ]
    },
    svelte: {
        type: "frontend",
        docsLink: "/docs/getting-started/client-sdk/sveltekit",
        slug: "svelte",
        title: "Svelte.js",
        snippets: [
            svelteSnippet
        ]
    },
    vue: {
        type: "frontend",
        docsLink: "/docs/getting-started/client-sdk/vuejs",
        slug: "vue",
        title: "Vue.js",
        snippets: [
            vueSnippet
        ]
    },
    express: {
        type: "backend",
        docsLink: "/docs/getting-started/4_backend-sdk/express",
        slug: "express",
        title: "Express",
        types: [
            "Backend",
            "Frontend"
        ],
        snippets: [
            expressSnippet,
            defaultFrontendSnippet
        ]
    },
    go: {
        type: "backend",
        docsLink: "/docs/getting-started/4_backend-sdk/go",
        slug: "go",
        title: "Golang",
        types: [
            "Backend",
            "Frontend"
        ],
        snippets: [
            goSnippet,
            defaultFrontendSnippet
        ]
    },
    "next-backend": {
        type: "backend",
        docsLink: "/docs/getting-started/client-sdk/nextjs",
        slug: "next-backend",
        title: "Next.js",
        types: [
            "Backend",
            "Frontend"
        ],
        snippets: [
            nextBackendSnippet,
            nextSnippet
        ]
    },
    node: {
        type: "backend",
        docsLink: "/docs/getting-started/4_backend-sdk/nodejs",
        slug: "node",
        title: "Node.js",
        types: [
            "Backend",
            "Frontend"
        ],
        snippets: [
            nodeSnippet,
            defaultFrontendSnippet
        ]
    }
};
const frontendProductLinks = Object.values(PRODUCTS).filter((product)=>{
    return product.type == "frontend";
});
const backendProductLinks = Object.values(PRODUCTS).filter((product)=>{
    return product.type == "backend";
});
const fullStackProductLinks = Object.values(PRODUCTS).filter((product)=>{
    return product.type == "fullstack";
});

// EXTERNAL MODULE: ./components/common/HighlightLogo/HighlightLogo.tsx + 2 modules
var HighlightLogo = __webpack_require__(44688);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./components/common/Footer/Footer.module.scss
var Footer_module = __webpack_require__(53480);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./components/common/Footer/Footer.tsx







const Footer = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Footer_module_default()).footer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_module_default()).footerBottom,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightLogo/* HighlightLogo */.R, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Footer_module_default()).socialDiv,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://twitter.com/highlightio",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
                                            className: (Footer_module_default()).socialIcon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.linkedin.com/company/highlightrun",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaLinkedinIn */.BUd, {
                                            className: (Footer_module_default()).socialIcon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://github.com/highlight/highlight",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaGithub */.hJX, {
                                            className: (Footer_module_default()).socialIcon
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Footer_module_default()).footerTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    emphasis: true,
                                    children: "Product"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (Footer_module_default()).footerList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/pricing",
                                                children: "Pricing"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://app.highlight.io/sign_up",
                                                children: "Sign up"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/#features",
                                                children: "Features"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/privacy",
                                                children: "Privacy & Security"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/#customers",
                                                children: "Customers"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Footer_module_default()).footerTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    emphasis: true,
                                    children: "Developers"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (Footer_module_default()).footerList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://feedback.highlight.run/changelog",
                                                children: "Changelog"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/docs",
                                                children: "Documentation"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Footer_module_default()).footerTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    emphasis: true,
                                    children: "Frameworks"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: (Footer_module_default()).footerList,
                                    children: Object.entries(PRODUCTS).map((param)=>{
                                        let [key, value] = param;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/for/".concat(value.slug),
                                                children: value.title
                                            })
                                        }, value.docsLink);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Footer_module_default()).footerTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    emphasis: true,
                                    children: "Contact & Legal"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (Footer_module_default()).footerList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/terms",
                                                children: "Terms of Service"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/privacy",
                                                children: "Privacy Policy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://careers.highlight.run/",
                                                children: "Careers"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:sales@highlight.io",
                                                children: "sales@highlight.io"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:security@highlight.io",
                                                children: "security@highlight.io"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Footer_module_default()).footerBottomMobile,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightLogo/* HighlightLogo */.R, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_module_default()).socialDiv,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://twitter.com/highlightio",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
                                    className: (Footer_module_default()).socialIcon
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.linkedin.com/company/highlightrun",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaLinkedinIn */.BUd, {
                                    className: (Footer_module_default()).socialIcon
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://github.com/highlight/highlight",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaGithub */.hJX, {
                                    className: (Footer_module_default()).socialIcon
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer_Footer = (Footer);


/***/ }),

/***/ 49879:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"highlightedBadge":"Products_highlightedBadge__6Uft5","subtleBadge":"Products_subtleBadge__Aj8X1","anchorFeature":"Products_anchorFeature__cQ3jd","buttonContainer":"Products_buttonContainer__eY3Z5","featureBox":"Products_featureBox__AJuwp","featureBoxIcon":"Products_featureBoxIcon__GvWMG","featureBoxText":"Products_featureBoxText__e06jy","snippet":"Products_snippet__KcE0k","divider":"Products_divider__GcLqX","hollowButton":"Products_hollowButton__mFcnB","docsButton":"Products_docsButton__s5paO","infoContainer":"Products_infoContainer__wQjcX","infoTitle":"Products_infoTitle__LO64z"};

/***/ }),

/***/ 53480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__8ba8J","footerTitle":"Footer_footerTitle__YyFKw","footerList":"Footer_footerList__VqicJ","footerBottom":"Footer_footerBottom__u2Y1_","footerBottomMobile":"Footer_footerBottomMobile__MN_9g","copyrightText":"Footer_copyrightText__YVr9H","socialDiv":"Footer_socialDiv__mojo7","socialIcon":"Footer_socialIcon__OIz7r","status":"Footer_status__fVYZR","statusDiv":"Footer_statusDiv__ipM1k","statusCircle":"Footer_statusCircle__XNZ7q"};

/***/ })

}]);